import type { Content, List as ListType } from 'mdast'
import * as React from 'react'

import { cn } from '~/styled'

import { List } from '../../list/List'

type MarkdownListProps = {
  node: ListType
  handleNode: (node: Content) => React.ReactElement<unknown>
  className?: string
}

export const MarkdownList = ({
  node,
  handleNode,
  className
}: MarkdownListProps) => (
  <List
    ordered={node.ordered || undefined}
    className={cn(
      '[&_p]:inline',
      '[&_p]:before:hidden',
      '[&_p]:after:hidden',
      className
    )}
  >
    {node.children?.map(handleNode)}
  </List>
)
